import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=0483e3d1"
import script from "../controllers/PaymentMethod.ts?vue&type=script&lang=ts&external"
export * from "../controllers/PaymentMethod.ts?vue&type=script&lang=ts&external"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&id=0483e3d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports